import { OnInit, OnDestroy, Renderer2, ElementRef } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from 'src/environments/environment';
import { MatTabGroup, MatDialog, MatDialogRef } from '@angular/material';
import { CashierService } from './cashier.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { ConfirmboxComponent } from '../confirmbox/confirmbox.component';
import { TournamentService } from 'src/app/tournamentpopup/tournament.service';
import { CreditCardValidator } from 'angular-cc-library';
import { HttpClient } from '@angular/common/http';
import { first } from 'rxjs/operators';
import { FlashMessagesService } from 'angular2-flash-messages';
import { MainService } from '../_services/main.service';
import { Store } from '@ngrx/store';
import { UserBalanceData } from './../store/actions/appActions';
var AddfundPopupComponent = /** @class */ (function () {
    function AddfundPopupComponent(_cashierService, _appService, formBuilder, datepipe, dialog, deviceService, spinner, http, _flashMessagesService, currencyPipe, tournamentService, renderer, elementRef, data, store) {
        var _this = this;
        this._cashierService = _cashierService;
        this._appService = _appService;
        this.formBuilder = formBuilder;
        this.datepipe = datepipe;
        this.dialog = dialog;
        this.deviceService = deviceService;
        this.spinner = spinner;
        this.http = http;
        this._flashMessagesService = _flashMessagesService;
        this.currencyPipe = currencyPipe;
        this.tournamentService = tournamentService;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.data = data;
        this.store = store;
        this.fundTabIndex = 1;
        this.displayedColumns = ['cardimg', 'name', 'lastfordigit', 'expirydate', 'action', 'check'];
        this.ticketsdisplayedColumns = ['ticket_no', 'contest', 'expired_on', 'ticket_value'];
        this.historydisplayedColumns = ['invoice', 'particular', 'trnType', 'amount', 'balance', 'date'];
        this.pendingdisplayedColumns = ['date', 'amount', 'action'];
        this.historyTable = HISTORY_ELEMENT_DATA;
        this.pendingCashTable = PENDING_ELEMENT_DATA;
        this.isMobile = false;
        this.submitted = false;
        this.cardSubmitted = false;
        this.cashOutSubmitted = false;
        this.verificatioSubmitted = false;
        this.uploadDocSubmitted = false;
        this.showUploadIdSuccessBox = false;
        this.showUploadBtn = false;
        this.cashOutConfirmation = false;
        this.cashOutForfeitConfirmation = false;
        this.filtertypeVal = 'all';
        this.currentTabIndex = 0;
        this.actCorsor = 0;
        this.endActHis = true;
        this.AllChecked = false;
        this.accountHistoryData = [];
        this.savedCardsData = [];
        this.pendingCashData = [];
        this.cardIds = [];
        this.config = null;
        this.primaryNumberOtp = '';
        this.otpSent = false;
        this.countDown = 0;
        this.timer = null;
        this.paypalForm = { promo_code: '', selected_package: '25.000', custom_amt: '' };
        this.paypal_amt = '';
        this.countNumber = 0;
        this.ipAddress = '192.168.0.149';
        this.popupTitle = 'Cashier';
        this.cashoutMethodWord = '';
        this.successMessage = '';
        this.errorMessage = '';
        this.promo_code_validation = { message: '', icon: 'far fa-check-circle', icon_color: '', validate: '' };
        this.ticketsData = [];
        this.paymentDetail = {};
        this.filtertype = [
            { 'key': 'all', 'value': 'All' },
            { 'key': 'add-fund', 'value': 'Deposit' },
            { 'key': 'add-fund,deposit_bonus', 'value': 'Deposit + Bonus' },
            { 'key': 'delete_league', 'value': 'Refund' },
            { 'key': 'deposit-admin', 'value': 'Admin Deposit' },
            { 'key': 'join_league', 'value': 'Entry' },
            { 'key': 'league_win', 'value': 'Prize' },
            { 'key': 'left_league', 'value': 'Left' },
            { 'key': 'paysafe-transaction-failed', 'value': 'Decline' },
            { 'key': 'signup_bonus', 'value': 'Signup Bonus' },
            { 'key': 'deposit-bonus-admin', 'value': 'Bonus From Admin' },
            { 'key': 'withdrawal-admin', 'value': 'Withdrawal Admin' },
            { 'key': 'withdrawal', 'value': 'Withdrawal' },
            { 'key': 'cashout-request', 'value': 'Cashout Request' },
            { 'key': 'refund-admin', 'value': 'Admin Refund' },
            { 'key': 'forfeit-bonus', 'value': 'Forfeit Bonus' },
            { 'key': 'cancel-user', 'value': 'Cancel Cashout' }
        ];
        this.countryList = [{ 'name': 'Canada', 'code': 'CA', 'id': '38' }, { 'name': 'United States', 'code': 'US', 'id': '224' }];
        this.stateList = [];
        this.dateList = [];
        this.monthList = [{ 'key': '1', 'value': 'Jan' }, { 'key': '2', 'value': 'Feb' }, { 'key': '3', 'value': 'Mar' }, { 'key': '4', 'value': 'April' }, { 'key': '5', 'value': 'May' }, { 'key': '6', 'value': 'Jun' }, { 'key': '7', 'value': 'Jul' }, { 'key': '8', 'value': 'Aug' }, { 'key': '9', 'value': 'Sep' }, { 'key': '10', 'value': 'Oct' }, { 'key': '11', 'value': 'Nov' }, { 'key': '12', 'value': 'Dec' }];
        this.yearList = [];
        this.financialYearList = [];
        this.currntYear = 0;
        this.FinancialYearSelected = 0;
        this.cashOutErr = false;
        this.disableCashOut = false;
        this.tooltipOption = {
            'placement': 'top',
            'tooltip-class': 'ptooltip'
        };
        this.amount = 0;
        this.loadingTicket = false;
        this.loadingCashOut = false;
        this.is_campaign = "0";
        this.tab = 0;
        this.hideAlert = false;
        this.uploadTab = false;
        this.selectedFile = null;
        this.validPayPal = true;
        this.min_deposit = 5;
        this.max_deposit = 1000;
        this.pending_orders = 0;
        this.order_message = "";
        this.selfExclusion = false;
        this.methodCardtype = '';
        this.darkMode = false;
        this.isDisable = false;
        this.isOpenOtpPopup = false;
        this.phoneNumerVerified = false;
        this.otpValue = '';
        this.updatePhoneNumber = '';
        this.phoneNumberControl = new FormControl('', [
            Validators.required,
            Validators.pattern(/^[0-9]{10}$/)
        ]);
        this.isOtpVerified = true;
        this.awsUploadUrl = environment.assetURL + "/assets/default/images/";
        this.isAwareVerification = false;
        this.parameters = data;
        this.store.select('authData').subscribe(function (state) {
            if (state[0]) {
                _this.currentUser = state[0];
                _this.user_id = _this.currentUser.id;
            }
        });
        this.isMobile = this.deviceService.isMobile();
        this.tab = (this.parameters.tab == 1) ? this.parameters.tab : 0;
        if (this.tab != 0)
            this.changeTabData(this.tab);
        this.store.select('DarkModeReducer').subscribe(function (state) {
            if (state.length > 0) {
                _this.darkMode = state[0].isDarkMode;
            }
        });
    }
    AddfundPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.site_currency = "" + environment.SITE_CURRENCY;
        this.currency_symbol = "" + environment.CURRENCY_SYMBOL;
        this.assetsUrl = "" + environment.assetURL;
        this.tournamentService.getIpAddress(this.user_id).subscribe(function (data) {
            if (data.ip)
                _this.ipAddress = data.ip;
        });
        this.currntYear = Number(this.datepipe.transform(Date.now(), 'y'));
        for (var index = 0; index < 5; index++) {
            this.financialYearList.push({ 'key': (this.currntYear - index).toString(), 'value': this.currntYear - index });
            if (index == 1)
                this.FinancialYearSelected = this.currntYear - index;
        }
        this.cardForm = this.formBuilder.group({
            card_number: ['', [CreditCardValidator.validateCCNumber]],
            name: ['', Validators.required],
            expiry: ['', [Validators.maxLength(7), CreditCardValidator.validateExpDate]],
            zip_code: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(10)]],
            user_id: [this.user_id, []],
            ip_address: [this.ipAddress, []],
            expiry_date: ['']
        });
        this.cashOutFrom = this.formBuilder.group({
            cashout_method: ['paypal', Validators.required],
            request_paypal: ['', [Validators.required, Validators.email]],
            cashout_address: [''],
            cashout_holder_name: [''],
            cashout_bank_name: [''],
            cashout_bank_address: [''],
            cashout_account_number: [''],
            cashout_swift_code: [''],
            request_amount: ['', [Validators.required, Validators.pattern("^[0-9]{1,9}(\.[0-9][0-9])?$"), Validators.min(20)]],
            phone_otp: ['']
        });
        this.verificationFrom = this.formBuilder.group({
            user_id: [this.user_id],
            FirstName: ['', Validators.required],
            LastName: ['', Validators.required],
            dd: ['', Validators.required],
            mm: ['', Validators.required],
            yyyy: ['', Validators.required],
            EmailAddress: ['', [Validators.required, Validators.email]],
            AddressLine1: ['', Validators.required],
            AddressLine2: [''],
            city: ['', Validators.required],
            PostalCode: ['', Validators.required],
            CountryCode: ['', Validators.required],
            StateCode: ['', Validators.required]
        });
        this.uploadDocForm = this.formBuilder.group({
            user_id: [this.user_id],
            document: ['', Validators.required],
            image: ['', Validators.required],
            file_name: ['', Validators.required],
        });
        if (this.user_id) {
            this.summaryInfo();
            this.getCurrentlyWinning();
            if (this.parameters && this.parameters.tab) {
                var timepause = setInterval(function () {
                    if (_this.tabGroup && _this.parameters.tab > 1) {
                        _this.tab = _this.parameters.tab;
                        _this.changeTab(_this.parameters.tab);
                        clearInterval(timepause);
                    }
                }, 300);
            }
        }
        this.setCashOutValidators();
        /**Load Jquery for hubzity event tracking */
        if (!this.checkJqueyLoaded() && this.is_campaign == "1") {
            var script = this.renderer.createElement('script');
            script.src = 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js';
            script.onload = function () {
                console.log('script loaded');
            };
            document.getElementsByTagName("head")[0].appendChild(script);
            //this.renderer.appendChild(this.elementRef.nativeElement, script);
        }
    };
    Object.defineProperty(AddfundPopupComponent.prototype, "c", {
        get: function () { return this.cardForm.controls; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddfundPopupComponent.prototype, "d", {
        get: function () { return this.cashOutFrom.controls; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddfundPopupComponent.prototype, "v", {
        get: function () { return this.verificationFrom.controls; },
        enumerable: true,
        configurable: true
    });
    AddfundPopupComponent.prototype.openMethodCard = function (methodName) {
        if (methodName == "card") {
            this.changeAddFundTab(0);
        }
        this.methodCardtype = methodName;
    };
    AddfundPopupComponent.prototype.summaryInfo = function () {
        var _this = this;
        this.spinner.show();
        this.sub_summaryInfo = this._cashierService.summaryInfo(this.user_id).subscribe(function (data) {
            if (data['status'] === 'success') {
                _this.summaryData = data['entities'];
                if (_this.summaryData.min_deposit != null)
                    _this.min_deposit = parseInt(_this.summaryData.min_deposit);
                if (_this.summaryData.max_deposit != null)
                    _this.max_deposit = parseInt(_this.summaryData.max_deposit);
                _this.pending_orders = (_this.summaryData.pending_orders != null) ? _this.summaryData.pending_orders : 0;
                _this.order_message = (_this.summaryData.order_message != null) ? _this.summaryData.order_message : "";
                _this.userData = data['entities'].userData;
                _this.zip_code_value = _this.userData.zip_code;
                var rolloverPercentage = 0;
                if (_this.userData.current_rollover_amount) {
                    rolloverPercentage = (_this.userData.current_rollover_amount / _this.userData.total_rollover) * 100;
                }
                _this.userData.rollover_percentage = rolloverPercentage.toFixed(2) + '%';
                var currentTime = Math.floor(new Date().getTime() / 1000);
                _this.selfExclusion = (currentTime < parseInt(_this.userData.exclusion)) ? true : false;
            }
            _this.spinner.hide();
        });
        this._cashierService.verficationInfo().subscribe(function (data) {
            if (data['status'] === 'success') {
                _this.isAwareVerification = data.entities.verification_method && data.entities.verification_method == 'aware' ? true : false;
            }
        });
    };
    AddfundPopupComponent.prototype.addFunds = function () {
        var _this = this;
        this.spinner.show();
        this._cashierService.addFunds(this.user_id).subscribe(function (data) {
            if (data.status === 'success') {
                _this.fundsData = data.entities;
                if (_this.fundsData.orderCount > 0 && _this.fundsData.isDefault === 'Y') {
                    _this.promo_code_value = '';
                }
                else {
                    _this.promo_code_value = _this.fundsData.promo_code;
                    _this.paypalForm.promo_code = _this.fundsData.promo_code;
                }
            }
            _this.spinner.hide();
        });
    };
    AddfundPopupComponent.prototype.changeFiltertype = function (val) {
        this.endActHis = true;
        this.actCorsor = 0;
        this.accountHistoryData = [];
    };
    AddfundPopupComponent.prototype.accountHistory = function () {
        var _this = this;
        if (this.endActHis && this.currentTabIndex == 5) {
            this._cashierService.accountHistory(this.user_id, this.filtertypeVal, this.actCorsor).subscribe(function (data) {
                if (data.status === 'success' && (data.entities.length > 0)) {
                    if (data.entities.length < 10)
                        _this.endActHis = false;
                    var newData_1 = [];
                    data.entities.forEach(function (element) {
                        var txn_action = _this.filtertype.find(function (i) { return (i.key) === (element.txn_action); });
                        var txn_val = '';
                        if (txn_action) {
                            txn_val = txn_action.value;
                        }
                        else {
                            txn_val = '-';
                        }
                        var balance = _this.formalPoints(element.balance);
                        var net_amount = _this.formalPoints(element.net_amount);
                        var newRow = { invoice: element.id, particular: ((element.title) ? element.title : 'Add Fund'), trnType: txn_val, amount: (_this.currency_symbol + '' + net_amount), balance: (_this.currency_symbol + '' + balance), date: _this.datepipe.transform(element.created.replace(' ', 'T'), 'MMM d/yy, h:mm a') };
                        newData_1.push(newRow);
                    });
                    _this.accountHistoryData = _this.accountHistoryData.concat(newData_1);
                    //this.accountHistoryData = this.accountHistoryData.concat(data.entities);
                    _this.actCorsor++;
                }
                else {
                    _this.endActHis = false;
                }
            });
        }
    };
    AddfundPopupComponent.prototype.getTickets = function () {
        var _this = this;
        this.loadingTicket = true;
        this._cashierService.getTickets(this.user_id).subscribe(function (data) {
            _this.loadingTicket = false;
            if (data.status === 'success' && (data.entities.length > 0)) {
                _this.ticketsData = data.entities;
            }
        });
    };
    AddfundPopupComponent.prototype.pendingCashOut = function () {
        var _this = this;
        this.loadingCashOut = true;
        this._cashierService.pendingCashOut(this.user_id).subscribe(function (data) {
            _this.loadingCashOut = false;
            if (data.status === 'success' && (data.entities.length > 0)) {
                var newData_2 = [];
                data.entities.forEach(function (rec) {
                    var newRow = { 'date': _this.datepipe.transform(rec.created, 'MMMM d/yy'), 'amount': rec.request_amount, 'id': rec.id };
                    newData_2.push(newRow);
                });
                _this.pendingCashData = [];
                _this.pendingCashData = _this.pendingCashData.concat(newData_2);
            }
            else {
                _this.pendingCashData = [];
            }
        });
    };
    AddfundPopupComponent.prototype.cancelCashOut = function (id) {
        var _this = this;
        this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
            width: '500px',
            data: { 'title': 'Cancel cash out request', 'body': 'Are you sure want to cancel this request?' }
        });
        this.confirmDialogRef.afterClosed()
            .subscribe(function (res) {
            if (res) {
                _this.spinner.show();
                var data = { id: id, user_id: _this.user_id };
                _this.sub_deleteCard = _this._cashierService.deleteCashOutRequest(data).subscribe(function (res) {
                    if (res.status === 'success') {
                        _this.pendingCashOut();
                        _this.summaryInfo();
                    }
                    _this.spinner.hide();
                });
            }
        });
    };
    AddfundPopupComponent.prototype.savedCards = function () {
        var _this = this;
        this.spinner.show();
        this._cashierService.savedCards(this.user_id).subscribe(function (data) {
            if (data['status'] === 'success' && (data['entities'])) {
                var cards_1 = [];
                _this.spinner.hide();
                if (data['entities'].paymentMethod) {
                    data['entities'].paymentMethod.forEach(function (element) {
                        var new_row = { cardimg: '', name: element.cardDetail.nickName, lastfordigit: element.cardDetail.lastDigits, expirydate: (element.cardDetail.month + '/' + element.cardDetail.year), action: 'far fa-trash-alt', check: false, id: element.id };
                        cards_1.push(new_row);
                    });
                    _this.savedCardsData = cards_1;
                }
            }
        });
    };
    AddfundPopupComponent.prototype.cardCheck = function (event, type, index, id) {
        var _this = this;
        if (type === 'all') {
            this.AllChecked = true;
            if (event.checked === true) {
                this.cardIds = [];
            }
            var dataSource = this.savedCardsData.map(function (x) { return Object.assign({}, x); });
            dataSource.forEach(function (element) {
                element.check = event.checked;
                _this.cardIds.push(element.id);
            });
            this.savedCardsData = [];
            this.savedCardsData = dataSource;
            if (event.checked === false) {
                this.cardIds = [];
            }
        }
        else {
            this.AllChecked = false;
            if (event.checked === false) {
                var card_index = this.cardIds.findIndex(function (x) { return (Number(x.id) === Number(id)); });
                this.cardIds.splice(card_index, 1);
            }
            else {
                this.cardIds.push(id);
            }
        }
    };
    AddfundPopupComponent.prototype.deleteCardPopup = function (id, index) {
        var _this = this;
        if (id === void 0) { id = null; }
        if (index === void 0) { index = null; }
        if ((this.cardIds && this.cardIds.length > 0) || (typeof id !== 'undefined' && id > 0)) {
            this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
                width: '500px',
                data: { 'title': 'Information', 'body': 'Are you sure you want to delete selected record?' }
            });
            this.confirmDialogRef.afterClosed()
                .subscribe(function (res) {
                if (res) {
                    if (typeof id !== 'undefined' && id > 0) {
                        _this.cardIds = [];
                        _this.cardIds.push(id);
                    }
                    _this.deleteSavedCards();
                }
            });
        }
        else {
            this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
                width: '500px',
                data: { 'title': 'Information', 'body': 'Please choose record to delete', 'type': 'alert-box' }
            });
            this.confirmDialogRef.afterClosed()
                .subscribe(function (res) {
                if (res) {
                }
            });
        }
    };
    AddfundPopupComponent.prototype.deleteSavedCards = function () {
        var _this = this;
        if (this.cardIds.length > 0) {
            var data = { 'user_id': this.user_id, 'ids': this.cardIds };
            this.spinner.show();
            this.sub_deleteCard = this._cashierService.deleteCards(data).subscribe(function (res) {
                if (res.status === 'success') {
                    var dataSource_1 = _this.savedCardsData.map(function (x) { return Object.assign({}, x); });
                    _this.cardIds.forEach(function (element) {
                        var card_index = dataSource_1.findIndex(function (x) { return (Number(x.id) === Number(element)); });
                        dataSource_1.splice(card_index, 1);
                    });
                    dataSource_1.forEach(function (element) {
                        element.check = false;
                    });
                    _this.cardIds = [];
                    _this.savedCardsData = [];
                    _this.savedCardsData = dataSource_1;
                    _this.spinner.hide();
                }
            });
        }
    };
    AddfundPopupComponent.prototype.getPayPalAmount = function (amt) {
        this.paypalForm.selected_package = amt;
        this.paypal_amt = '';
        this.validPayPal = true;
        this.amount = this.formalPoints(this.paypalForm.selected_package);
    };
    AddfundPopupComponent.prototype.onBlur = function ($event) {
        this.paypalForm.selected_package = '';
        this.paypal_amt = $event.target.value;
        this.amount = this.formalPoints(this.paypal_amt);
        if (this.tab == 1 && this.fundTabIndex == 1) {
            if (this.amount > this.max_deposit && this.amount != '') {
                this.validPayPal = false;
                if ($event.type != null && $event.type == 'focusout')
                    this._flashMessagesService.show("The maximum deposit is $" + this.max_deposit, { cssClass: 'alert-danger', timeout: 5000, showCloseBtn: true });
            }
            else if (this.amount < this.min_deposit && this.amount != '') {
                this.validPayPal = false;
                if ($event.type != null && $event.type == 'focusout')
                    this._flashMessagesService.show("The minimum deposit is $" + this.min_deposit, { cssClass: 'alert-danger', timeout: 5000, showCloseBtn: true });
            }
            else {
                this.validPayPal = true;
            }
        }
    };
    AddfundPopupComponent.prototype.checkPromoCode = function (type) {
        var _this = this;
        if (this.paypalForm.promo_code) {
            if (((this.paypal_amt !== '' && Number(this.paypal_amt) < 3))) {
                this._flashMessagesService.show("The Charge amount field must contain a number greater than or equal to 3.", { cssClass: 'alert-danger', timeout: 5000, showCloseBtn: true });
            }
            else {
                var data = { 'user_id': this.user_id, 'order_amount': ((this.paypal_amt) ? this.paypal_amt : this.paypalForm.selected_package), 'promo_code': this.paypalForm.promo_code };
                this.sub_checkPromoCode = this._cashierService.checkPromoCodeByAmt(data).subscribe(function (res) {
                    if (res.status === 'success') {
                        _this.promo_code_validation.message = res.msg;
                        _this.promo_code_validation.validate = res.validate;
                        if (res.validate === 'yes') {
                            _this.promo_code_validation.icon = 'far fa-check-circle';
                            _this.promo_code_validation.icon_color = '#52a328';
                        }
                        else {
                            _this.promo_code_validation.icon = 'far fa-times-circle';
                            _this.promo_code_validation.icon_color = '#e8132e';
                        }
                    }
                    else {
                        _this._flashMessagesService.show(res.msg, { cssClass: 'alert-danger', timeout: 5000, showCloseBtn: true });
                    }
                });
            }
        }
        else {
            this._flashMessagesService.show("Promo code is required.", { cssClass: 'alert-danger', timeout: 5000, showCloseBtn: true });
        }
    };
    AddfundPopupComponent.prototype.handleDepositSuccess = function (data) {
        if (data && data.status) {
            this.addFunds();
        }
        else {
            this.scrollToTop();
        }
    };
    AddfundPopupComponent.prototype.scrollToTop = function () {
        this.addFundFormElementTop.nativeElement.scrollTop = 0;
    };
    AddfundPopupComponent.prototype.onCardSubmit = function () {
        var _this = this;
        this.cardSubmitted = true;
        if (this.cardForm.invalid) {
            return;
        }
        else {
            this.isDisable = true;
            this.spinner.show();
            var cardExpiryDate = this.c.expiry.value.replace(/ /gi, '');
            this.cardForm.controls['expiry_date'].setValue(cardExpiryDate);
            this.sub_addNewCard = this._cashierService.addNewCard(this.cardForm.value).pipe(first()).subscribe(function (data) {
                _this.isDisable = false;
                if (data.status === 'success') {
                    _this.changeTab(1);
                    _this.cardForm.controls['zip_code'].setValue('');
                }
                else {
                    _this._flashMessagesService.show(data.message, { cssClass: 'alert-danger', timeout: 7000, showCloseBtn: true });
                }
                _this.spinner.hide();
                _this.cardSubmitted = false;
            }, function (error) {
                _this.spinner.hide();
                console.log(error);
            });
        }
    };
    AddfundPopupComponent.prototype.getCurrentlyWinning = function () {
        var _this = this;
        if (this.currentUser) {
            this.sub_currentlyWinning = this._appService.getCurrentlyWinning(this.user_id).subscribe(function (res) {
                if (res) {
                    _this.winAmt = res.currently_winning;
                }
            });
        }
    };
    AddfundPopupComponent.prototype.setCashOutValidators = function () {
        var request_paypal = this.cashOutFrom.get('request_paypal');
        var cashout_address = this.cashOutFrom.get('cashout_address');
        var cashout_holder_name = this.cashOutFrom.get('cashout_holder_name');
        var cashout_bank_name = this.cashOutFrom.get('cashout_bank_name');
        var cashout_bank_address = this.cashOutFrom.get('cashout_bank_address');
        var cashout_account_number = this.cashOutFrom.get('cashout_account_number');
        var cashout_swift_code = this.cashOutFrom.get('cashout_swift_code');
        var request_amount = this.cashOutFrom.get('request_amount');
        this.cashOutFrom.get('cashout_method').valueChanges
            .subscribe(function (cashout_method) {
            if (cashout_method === 'paypal') {
                request_paypal.setValidators([Validators.required, Validators.email]);
                request_amount.setValidators([Validators.required, Validators.pattern("^[0-9]{1,9}(\.[0-9][0-9])?$"), Validators.min(20)]);
                cashout_address.setValidators(null);
                cashout_holder_name.setValidators(null);
                cashout_bank_name.setValidators(null);
                cashout_bank_address.setValidators(null);
                cashout_account_number.setValidators(null);
                cashout_swift_code.setValidators(null);
            }
            else if (cashout_method === 'email_money_transfer') {
                request_paypal.setValidators(null);
                cashout_address.setValidators(null);
                request_amount.setValidators([Validators.required, Validators.pattern("^[0-9]{1,9}(\.[0-9][0-9])?$"), Validators.min(20)]);
                cashout_holder_name.setValidators(null);
                cashout_bank_name.setValidators(null);
                cashout_bank_address.setValidators(null);
                cashout_account_number.setValidators(null);
                cashout_swift_code.setValidators(null);
            }
            else if (cashout_method === 'wire_transfer') {
                cashout_holder_name.setValidators([Validators.required]);
                request_amount.setValidators([Validators.required, Validators.pattern("^[0-9]{1,9}(\.[0-9][0-9])?$"), Validators.min(1000)]);
                cashout_address.setValidators([Validators.required]);
                cashout_bank_name.setValidators([Validators.required]);
                cashout_bank_address.setValidators([Validators.required]);
                cashout_account_number.setValidators([Validators.required]);
                cashout_swift_code.setValidators([Validators.required]);
                request_paypal.setValidators(null);
            }
            request_paypal.updateValueAndValidity();
            request_amount.updateValueAndValidity();
            cashout_address.updateValueAndValidity();
            cashout_holder_name.updateValueAndValidity();
            cashout_bank_name.updateValueAndValidity();
            cashout_bank_address.updateValueAndValidity();
            cashout_account_number.updateValueAndValidity();
            cashout_swift_code.updateValueAndValidity();
        });
    };
    AddfundPopupComponent.prototype.onCashOutSubmit = function () {
        this.cashOutSubmitted = true;
        // stop here if form is invalid
        if (this.cashOutFrom.invalid) {
            return;
        }
        else if (parseFloat(this.cashOutFrom.value.request_amount) > parseFloat(this.userData.redeemable_balance)) {
            this._flashMessagesService.show("The Request amount must be less than or equal available balance.", { cssClass: 'alert-danger', timeout: 7000, showCloseBtn: true });
        }
        else {
            if (this.cashOutFrom.value.cashout_method === 'email_money_transfer') {
                this.cashoutMethodWord = this.cashOutFrom.value.cashout_method.replace(/_/g, ' ');
                this.cashoutMethodWord += ' (CAD Only)';
            }
            else {
                this.cashoutMethodWord = this.cashOutFrom.value.cashout_method.replace(/_/g, ' ');
            }
            if (parseFloat(this.userData.bonus_amount) > 0) {
                this.cashOutForfeitConfirmation = true;
            }
            else {
                this.cashOutConfirmation = true;
            }
        }
    };
    AddfundPopupComponent.prototype.openOtpPopup = function () {
        this.otpValue = '';
        this.spinner.show();
        this.cashOutSubmitted = true;
        this.primaryNumberOtp = (this.currentUser && this.currentUser.primary_number && this.currentUser.primary_number) ? this.currentUser.primary_number.slice(-4) : "";
        if (this.primaryNumberOtp) {
            this.sendPhoneOtp();
        }
        else {
            this.isOpenOtpPopup = false;
            this.phoneNumerVerified = true;
            this.spinner.hide();
        }
    };
    AddfundPopupComponent.prototype.sendPhoneOtp = function (phoneNumber) {
        var _this = this;
        if (phoneNumber === void 0) { phoneNumber = ''; }
        this._cashierService.sendPhoneOtp(phoneNumber).subscribe(function (data) {
            _this.isOtpVerified = false;
            if (data && data.status == 'success') {
                _this.isOtpVerified = true;
                _this.phoneNumerVerified = false;
                _this.isOpenOtpPopup = true;
                _this.otpSent = true;
                _this.countDown = 60;
                _this.getCountdown();
                _this.spinner.hide();
                if (phoneNumber) {
                    _this.currentUser['primary_number'] = phoneNumber;
                    _this.primaryNumberOtp = phoneNumber.slice(-4);
                }
                ;
            }
            else {
                if (phoneNumber) {
                    _this.phoneNumerVerified = true;
                    _this.isOpenOtpPopup = false;
                }
                else {
                    _this.isOpenOtpPopup = true;
                    _this.phoneNumerVerified = false;
                }
                _this.spinner.hide();
                setTimeout(function () {
                    _this._flashMessagesService.show(data.message, { cssClass: 'alert-danger', timeout: 10000, showCloseBtn: false });
                }, 500);
            }
        });
    };
    AddfundPopupComponent.prototype.submitPhoneVerified = function () {
        if (this.phoneNumberControl.valid) {
            var primaryNumber = "+1 " + this.phoneNumberControl.value;
            this.otpValue = '';
            this.spinner.show();
            this.cashOutSubmitted = true;
            this.sendPhoneOtp(primaryNumber);
        }
    };
    AddfundPopupComponent.prototype.getErrorMessage = function () {
        if (this.phoneNumberControl.hasError('required')) {
            return 'Phone Number is required.';
        }
        if (this.phoneNumberControl.hasError('pattern')) {
            return 'Please enter a valid phone number.';
        }
        return '';
    };
    AddfundPopupComponent.prototype.submitVerify = function () {
        this.cashOutFrom.patchValue({ phone_otp: this.otpValue });
        this.cashOutSubmit('confirm');
    };
    AddfundPopupComponent.prototype.validateOtp = function () {
        this.cashOutSubmitted = true;
        if (this.otpValue && this.otpValue.length == 6)
            this.cashOutSubmitted = false;
    };
    AddfundPopupComponent.prototype.getCountdown = function () {
        var _this = this;
        if (this.timer == null) {
            this.timer = setInterval(function () {
                _this.countDown--;
                if (_this.countDown == 0) {
                    _this.timer.clearInterval();
                    _this.timer = null;
                }
            }, 1000);
        }
    };
    AddfundPopupComponent.prototype.cashOutSubmit = function (type) {
        var _this = this;
        if (type === 'cancel') {
            this.cashOutFrom.reset();
            this.cashOutFrom.controls['cashout_method'].setValue('paypal');
            this.cashOutSubmitted = false;
            this.cashOutConfirmation = false;
            this.cashOutForfeitConfirmation = false;
        }
        else if (type === 'back') {
            this.cashOutSubmitted = false;
            this.cashOutConfirmation = false;
            this.cashOutForfeitConfirmation = false;
        }
        else {
            // confirmCashOut
            this.spinner.show();
            var address = '';
            var formFields = this.cashOutFrom.value;
            var fromData = {
                'user_id': this.user_id,
                'amount': formFields.request_amount,
                'method': formFields.cashout_method
            };
            if (formFields && formFields.phone_otp)
                fromData['phone_otp'] = formFields.phone_otp;
            if (this.cashOutFrom.value.cashout_method === 'paypal') {
                fromData['address'] = formFields.request_paypal;
            }
            else if (this.cashOutFrom.value.cashout_method === 'cheque_by_email') {
                fromData['address'] = formFields.cashout_address;
            }
            else if (this.cashOutFrom.value.cashout_method === 'wire_transfer') {
                fromData['address'] = formFields.cashout_address;
                fromData['bank_holder_name'] = formFields.cashout_holder_name;
                fromData['bank_name'] = formFields.cashout_bank_name;
                fromData['bank_address'] = formFields.cashout_bank_address;
                fromData['bank_account_number'] = formFields.cashout_account_number;
                fromData['bank_swift_code'] = formFields.cashout_swift_code;
            }
            this.sub_confirmCashOut = this._cashierService.confirmCashOut(fromData).pipe(first()).subscribe(function (data) {
                if (data.status === 'success') {
                    _this.summaryInfo();
                    _this.pendingCashOut();
                    _this.cashOutFrom.reset();
                    _this.cashOutFrom.controls['cashout_method'].setValue('paypal');
                    _this.cashOutSubmitted = false;
                    _this.cashOutConfirmation = false;
                    _this.cashOutForfeitConfirmation = false;
                    _this.isOpenOtpPopup = false;
                    _this.phoneNumerVerified = false;
                    _this.countDown = 0;
                    setTimeout(function () {
                        _this._flashMessagesService.show(data.msg, { cssClass: 'alert-success', timeout: 7000, showCloseBtn: true });
                    }, 500);
                }
                else {
                    _this.cashOutSubmitted = true;
                    _this._flashMessagesService.show(data.msg, { cssClass: 'alert-danger', timeout: 7000, showCloseBtn: true });
                }
                _this.spinner.hide();
            }, function (error) {
                _this.spinner.hide();
                console.log(error);
            });
        }
    };
    AddfundPopupComponent.prototype.cashOutForfitSubmit = function (type) {
        if (type === 'cancel') {
            this.cashOutFrom.reset();
            this.cashOutFrom.controls['cashout_method'].setValue('paypal');
            this.cashOutSubmitted = false;
            this.cashOutConfirmation = false;
            this.cashOutForfeitConfirmation = false;
        }
        else {
            this.cashOutConfirmation = true;
            this.cashOutForfeitConfirmation = false;
        }
    };
    AddfundPopupComponent.prototype.goToVerify = function () {
        this.changeTab(7);
    };
    AddfundPopupComponent.prototype.changeTab = function (val) {
        this.validPayPal = true;
        if (this.fundTabIndex && val > 3) {
            val = val - 2;
        }
        this.tabGroup.selectedIndex = val;
    };
    AddfundPopupComponent.prototype.changeTabData = function (val) {
        if (this.fundTabIndex && val > 1) {
            val = val + 2;
        }
        this.validPayPal = true;
        this.currentTabIndex = val;
        this.popupTitle = 'Cashier';
        if (val === 0) {
            this.summaryInfo();
        }
        else if (val === 1) {
            this.paymentDetail = { status: '', message: '', class: '' };
            this.checkUserEligibility();
        }
        else if (val === 2) {
            this.cardSubmitted = false;
            this.cardForm.controls['card_number'].setValue('');
            this.cardForm.controls['name'].setValue('');
            this.cardForm.controls['expiry'].setValue('');
        }
        else if (val === 3) {
            this.savedCards();
        }
        else if (val === 4) {
            if (this.userData.payment_verified === 'N') {
                this.cashOutErr = true;
                this.disableCashOut = true;
            }
            this.pendingCashOut();
        }
        else if (val === 6) {
            this.getTickets();
        }
        else if (val === 7) {
            this.showVerification();
        }
    };
    AddfundPopupComponent.prototype.changeAddFundTab = function (val) {
        this.fundTabIndex = val;
        this.promo_code_validation = { message: '', icon: 'far fa-check-circle', icon_color: '', validate: '' };
        if (val === 1) {
            this.methodCardtype = "paypal";
            this.initConfig();
        }
        else {
            this.methodCardtype = "card";
        }
    };
    AddfundPopupComponent.prototype.initConfig = function () {
        var _this = this;
        this.spinner.show();
        this.payPalConfig = {
            currency: "" + environment.SITE_CURRENCY,
            clientId: "" + environment.PAYPAL_CLIENT_ID,
            createOrderOnClient: function (data) { return ({
                intent: 'CAPTURE',
                purchase_units: [
                    {
                        amount: {
                            currency_code: "" + environment.SITE_CURRENCY,
                            value: (_this.amount > 0) ? _this.amount : 25.00
                        }
                    }
                ]
            }); },
            advanced: {
                commit: 'true'
            },
            style: {
                tagline: true,
                label: 'checkout',
                size: "responsive",
                shape: "pill",
                layout: "horizontal"
            },
            onApprove: function (data, actions) {
                data['paymentID'] = data['orderID'];
                var fromData = { 'payment_id': data['paymentID'], 'user_id': _this.user_id, 'promo_code': _this.paypalForm.promo_code, 'order_amount': ((_this.paypal_amt) ? _this.paypal_amt : _this.paypalForm.selected_package), 'response': data, 'currency': "" + environment.SITE_CURRENCY, 'user_agent': _this.deviceService.userAgent, 'ip': _this.ipAddress };
                _this.spinner.show();
                _this._cashierService.validatePaypal(fromData).pipe(first()).subscribe(function (response) {
                    if (response.error != true) {
                        return actions.order.capture().then(function (details) {
                            var total_order_amount = parseFloat(fromData.order_amount) + parseFloat(response.bonus_amount);
                            _this.paymentDetail = { status: 'processing', message: 'Please check back momentarily and refresh the page. <br><br> You will receive an email receipt confirming if your deposit has been successful or unsuccessful!', class: 'pending' };
                            var counter = 0;
                            var timeInt = setInterval(function () {
                                _this.verifyPaypalPaymentStatus(fromData['payment_id'], function (checkData) {
                                    counter++;
                                    if (counter == 3 || checkData.status != 'pending') {
                                        //Break the real time payment status checking if it is not getting success/failure in x (counter) calls
                                        clearInterval(timeInt);
                                        if (checkData.status == 'success') {
                                            _this.userData.dollar_balance = parseFloat(_this.userData.dollar_balance) + total_order_amount;
                                            /**Update store data */
                                            _this.store.dispatch(new UserBalanceData(_this.userData.dollar_balance));
                                            _this.paymentDetail = { status: 'completed', message: '$' + (+total_order_amount).toFixed(2).replace(/(\.0+|0+)$/, '') + ' has been added to your account', class: 'success' };
                                        }
                                        else if (checkData.status == 'failed') {
                                            _this.paymentDetail = { status: 'failed', message: checkData.message, class: 'failure' };
                                        }
                                        else {
                                            _this.paymentDetail = { status: 'processing', message: 'Please check back momentarily and refresh the page. <br><br> You will receive an email receipt confirming if your deposit has been successful or unsuccessful!', class: 'pending' };
                                        }
                                        //this._flashMessagesService.show(checkData.message, { cssClass: 'alert-success',timeout: 7000,showCloseBtn:true } );
                                        _this.spinner.hide();
                                    }
                                });
                            }, 1500);
                        });
                    }
                    else {
                        _this._flashMessagesService.show((response.errorMessage).join('<br />'), { cssClass: 'alert-danger', timeout: 7000, showCloseBtn: true });
                        _this.spinner.hide();
                    }
                });
            },
            onCancel: function (data, actions) {
            },
            onError: function (err) {
                console.log('OnError', err);
                _this._flashMessagesService.show("Something went wrong. Please try again later.", { cssClass: 'alert-danger', timeout: 7000, showCloseBtn: true });
            },
            onClick: function () {
            },
        };
        if (this.payPalConfig) {
            this.spinner.hide();
        }
    };
    AddfundPopupComponent.prototype.verifyPaypalPaymentStatus = function (payment_id, callback) {
        this._cashierService.checkPaypalPaymentStatus(payment_id).pipe(first()).subscribe(function (data) {
            callback(data);
        }, function (error) {
            callback(error);
        });
    };
    AddfundPopupComponent.prototype.savePaypalAmount = function (fromData) {
        var _this = this;
        this.sub_confirmCashOut = this._cashierService.validatePaypal(fromData).pipe(first()).subscribe(function (data) {
            if (data.status === 'success') {
                //this._flashMessagesService.show("Your payment has been successfully submitted.", { cssClass: 'alert-danger',timeout: 7000,showCloseBtn:true } );
                var counter = 0;
                _this.spinner.show();
                var timeInt = setInterval(function () {
                    _this.verifyPaypalPaymentStatus(fromData['payment_id'], function (checkData) {
                        counter++;
                        if (counter == 8 || checkData.status != 'pending') {
                            clearInterval(timeInt);
                            if (checkData.status == 'success') {
                                var total_order_amount = parseFloat(fromData.order_amount) + parseFloat(data.bonus_amount);
                                _this.userData.dollar_balance = parseFloat(_this.userData.dollar_balance) + total_order_amount;
                                /**Update store data */
                                _this.store.dispatch(new UserBalanceData(_this.userData.dollar_balance));
                            }
                            _this._flashMessagesService.show(checkData.message, { cssClass: 'alert-success', timeout: 7000, showCloseBtn: true });
                            _this.spinner.hide();
                        }
                        if (_this.userData.dollar_balance != null && _this.userData.dollar_balance == 0 && _this.is_campaign == "1")
                            _this.trackHubZityEvents("5");
                    });
                }, 1500);
            }
            else {
                _this._flashMessagesService.show(data.errorMessage, { cssClass: 'alert-danger', timeout: 7000, showCloseBtn: true });
                _this.spinner.hide();
            }
        }, function (error) {
            console.log(error);
        });
    };
    AddfundPopupComponent.prototype.keyPress = function (event) {
        var _this = this;
        try {
            var pattern = /[0-9\+\.\ ]/;
            var inputChar = String.fromCharCode(event.charCode);
            if (event.keyCode !== 8 && !pattern.test(inputChar)) {
                event.preventDefault();
            }
            if (this.tab == 1 && this.fundTabIndex == 1) {
                setTimeout(function () {
                    if (event != null && event.target != null && parseFloat(event.target.value) >= _this.min_deposit && parseFloat(event.target.value) <= _this.max_deposit) {
                        _this.validPayPal = true;
                    }
                }, 100);
            }
        }
        catch (_a) {
        }
    };
    AddfundPopupComponent.prototype.showVerification = function () {
        var currentTime = Math.floor(new Date().getTime() / 1000);
        var diff = currentTime - this.userData.doc_upload_time;
        var min = (diff > 0) ? diff / 60 : 0;
        this.showUploadIdSuccessBox = (min < 30) ? true : false;
        this.dateList = [];
        this.yearList = [];
        for (var index = 1; index <= 31; index++) {
            this.dateList.push({ 'key': index.toString(), 'value': index });
        }
        for (var index = Number(this.datepipe.transform(Date.now(), 'y')); index >= 1905; index--) {
            this.yearList.push({ 'key': index.toString(), 'value': index });
        }
        if (this.userData) {
            var dob = this.userData.dob.split('-');
            var dd = Number((dob[2]) ? dob[2] : '');
            var mm = Number((dob[1]) ? dob[1] : '');
            var yy = Number((dob[0]) ? dob[0] : '');
            this.v['dd'].setValue(dd.toString());
            this.v['yyyy'].setValue(yy.toString());
            this.v['mm'].setValue(mm.toString());
            this.v['EmailAddress'].setValue(this.userData.email);
            this.v['AddressLine1'].setValue(this.userData.address);
            this.v['city'].setValue(this.userData.hometown);
            this.v['PostalCode'].setValue(this.userData.zip_code);
        }
    };
    AddfundPopupComponent.prototype.onVerificationSubmit = function (el) {
        var _this = this;
        this.verificatioSubmitted = true;
        // stop here if form is invalid
        if (this.verificationFrom.invalid) {
            return;
        }
        else {
            this.spinner.show();
            this.sub_confirmCashOut = this._cashierService.tsevoVerification(this.verificationFrom.value).pipe(first()).subscribe(function (data) {
                if (data.status == "success") {
                    _this.hideAlert = true;
                    _this._flashMessagesService.show('Thanks for providing the information. You will receive an email when it has been reviewed. This usually takes less than an hour.', { cssClass: 'alert-success', timeout: 10000, showCloseBtn: true });
                    el.scrollIntoView();
                }
                else {
                    _this.userData.verification_attempts++;
                }
                _this.spinner.hide();
            }, function (error) {
                _this.spinner.hide();
                console.log(error);
            });
        }
    };
    AddfundPopupComponent.prototype.onSelectFile = function (files) {
        var _this = this;
        var file1 = files[0];
        var file = file1;
        var pattern = /image-*/;
        var reader = new FileReader();
        if (!file.type.match(pattern)) {
            alert('invalid format');
            return;
        }
        reader.onload = function (e) { return _this.imageSrc = reader.result; };
        reader.readAsDataURL(file);
        // var base64result =this._handleReaderLoaded.bind(this);
        this.uploadDocForm.get('file_name').setValue(file.name);
        this.uploadDocForm.get('image').setValue(files[0]);
        this.selectedFile = files[0];
        // reader.onloadend = base64result;
        //reader.readAsDataURL(file);
        this.showUploadBtn = true;
    };
    AddfundPopupComponent.prototype.resetFile = function () {
        this.imageSrc = null;
    };
    AddfundPopupComponent.prototype._handleReaderLoaded = function (e) {
        // let reader = e.target;
        // var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
        // this.uploadDocForm.get('image').setValue(base64result);   
    };
    AddfundPopupComponent.prototype.onDocSubmit = function () {
        var _this = this;
        this.uploadDocSubmitted = true;
        // stop here if form is invalid
        if (this.uploadDocForm.invalid) {
            return;
        }
        else {
            this.spinner.show();
            var form = new FormData();
            form.append('document', this.selectedFile, this.selectedFile.name);
            form.append('login_user_id', this.currentUser.id);
            this.sub_confirmCashOut = this._cashierService.submitVerificationDocument(form).pipe(first()).subscribe(function (data) {
                if (data.status === 'success') {
                    setTimeout(function () { _this.showUploadIdSuccessBox = true; }, 5000);
                    _this.summaryInfo();
                    _this._flashMessagesService.show('Thanks for uploading your ID. You will receive an email when it has been reviewed. This usually takes less than an hour.', { cssClass: 'alert-success', timeout: 10000, showCloseBtn: true });
                    _this.userData.doc_upload_time = Math.floor(new Date().getTime() / 1000);
                }
                else {
                    _this._flashMessagesService.show('Something went wrong. Please try again later.', { cssClass: 'alert-danger', timeout: 5000, showCloseBtn: true });
                }
                _this.spinner.hide();
            }, function (error) {
                _this.spinner.hide();
                console.log(error);
            });
        }
    };
    AddfundPopupComponent.prototype.formalPoints = function (val) {
        if (typeof val !== 'undefined' && val !== null) {
            var abc = val.toString().split('.');
            if (abc[1] && Number(abc[1]) > 0) {
                var dec = abc[1].split('');
                if (dec[1] && Number(dec[1]) === 0 && Number(dec[0]) > 0) {
                    return (abc[0] + '.' + dec[0] + dec[1]);
                }
                else if (dec[0] && Number(dec[0]) === 0) {
                    return abc[0];
                }
                else {
                    return (abc[0] + '.' + abc[1].slice(0, 2));
                }
            }
            else {
                return abc[0];
            }
        }
        else {
            return '';
        }
    };
    AddfundPopupComponent.prototype.ngOnDestroy = function () {
        if (this.sub_deleteCard) {
            this.sub_deleteCard.unsubscribe();
        }
        if (this.sub_addNewCard) {
            this.sub_addNewCard.unsubscribe();
        }
        if (this.sub_summaryInfo) {
            this.sub_summaryInfo.unsubscribe();
        }
        if (this.sub_confirmCashOut) {
            this.sub_confirmCashOut.unsubscribe();
        }
        if (this.sub_stateList) {
            this.sub_stateList.unsubscribe();
        }
    };
    AddfundPopupComponent.prototype.getStateList = function (country_code) {
        var _this = this;
        var country = this.countryList.find(function (x) { return (x.code == country_code); });
        this.sub_stateList = this._cashierService.stateList(country.id).subscribe(function (res) {
            if (res.status === 'success') {
                _this.stateList = res.entities;
            }
        });
    };
    AddfundPopupComponent.prototype.checkUserEligibility = function () {
        var _this = this;
        this.spinner.show();
        this.tournamentService.getUserLocation(this.user_id, function (locationData) {
            var eligibilityData = {
                'user_id': _this.user_id,
                'PublicIP': locationData['ip'],
                'country_name': locationData['country'],
                'state_name': locationData['state'],
                'user_dob': locationData['user_dob'],
                'type': 'cash',
                'display_name': _this.currentUser['drafters_id']
            };
            _this._cashierService.checkUserEligibility(eligibilityData).subscribe(function (res) {
                _this.spinner.hide();
                if (typeof res !== 'undefined') {
                    if (res.status == 'success') {
                        _this.submitted = false;
                        _this.addFunds();
                        _this.initConfig();
                    }
                    else {
                        var isDobWarning = _this.currentUser && _this.currentUser.verification_method == 'aware' && _this.currentUser.payment_verified == 'N' && _this.currentUser.verify_before_deposits && res.type == 'dob';
                        if (!isDobWarning) {
                            _this.changeTab(0);
                            _this.confirmDialogRef = _this.dialog.open(ConfirmboxComponent, {
                                width: (res.type == 'age_18') ? '500px' : '800px',
                                data: { 'title': "Eligibility Warning", 'body': res.message, 'type': res.type }
                            });
                            _this.confirmDialogRef.afterClosed()
                                .subscribe(function (res) { });
                        }
                    }
                }
            });
        });
    };
    AddfundPopupComponent.prototype.cashOutErrHide = function () {
        this.cashOutErr = false;
    };
    AddfundPopupComponent.prototype.uploadDocAction = function (action) {
        if (action == 'change')
            this.uploadTab = true;
        else
            this.hideAlert = true;
    };
    AddfundPopupComponent.prototype.trackHubZityEvents = function (TRACKING_CONVERSION_STAGE) {
        console.log("TRACKING_CONVERSION_STAGE: ", TRACKING_CONVERSION_STAGE);
        /* Hubzity conversion stage tracking start */
        if (window.trackingStoreSession !== undefined && window.trackingConversion !== undefined) {
            window.trackingStoreSession();
            window.trackingConversion(TRACKING_CONVERSION_STAGE);
        }
        else {
            var head = document.getElementsByTagName("head")[0];
            var trackingScript = document.createElement("script");
            trackingScript.setAttribute("async", 'true');
            trackingScript.setAttribute("src", "//static.rtbaxs.io/tracking.min.js?ts=" + new Date().getTime());
            trackingScript.addEventListener("load", function () {
                window.trackingStoreSession();
                window.trackingConversion(TRACKING_CONVERSION_STAGE); //use this in each following pages in case you want to track their loading
            });
            trackingScript.addEventListener("error", function () {
                console.log("Failed to load Hubzity tracking SDK");
            });
            head.appendChild(trackingScript);
        }
        /* Hubzity conversion stage tracking end */
    };
    AddfundPopupComponent.prototype.checkJqueyLoaded = function () {
        var isFound = false;
        var scripts = document.getElementsByTagName("script");
        for (var i = 0; i < scripts.length; ++i) {
            if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("1.7.1/jquery.min.js")) {
                isFound = true;
            }
        }
        //console.log("jquery loaded:",isFound);
        return isFound;
    };
    AddfundPopupComponent.prototype.sendFinancialReport = function () {
        var _this = this;
        if (this.FinancialYearSelected == 0) {
            this.setErrorSuccessMessage('Please select year', 'error', 3000);
            return false;
        }
        this.sub_financial = this._cashierService.getFinancialReport(this.user_id, this.FinancialYearSelected).subscribe(function (res) {
            _this.setErrorSuccessMessage(res.message, res['status'] == 'success' ? 'success' : 'error', 5000);
        });
    };
    AddfundPopupComponent.prototype.setErrorSuccessMessage = function (message, type, time) {
        var _this = this;
        if (time === void 0) { time = 5000; }
        this.errorMessage = '';
        this.successMessage = '';
        setTimeout(function () {
            _this.errorMessage = '';
            _this.successMessage = '';
        }, time);
        if (type == 'success') {
            this.errorMessage = '';
            this.successMessage = message;
        }
        else {
            this.successMessage = '';
            this.errorMessage = message;
        }
    };
    return AddfundPopupComponent;
}());
export { AddfundPopupComponent };
var ELEMENT_DATA = [
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/visa-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/master-card-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/maestro-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/cirrus-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
    { cardimg: "" + environment.assetURL + '/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
];
var HISTORY_ELEMENT_DATA = [
    { invoice: '4586', particular: 'Refund for nfl league (Week 15 cobra 2QB($450 to 1st)', trnType: 'Left', amount: '$22', balance: '$500.57', date: '18 Oct 2018' },
    { invoice: '4586', particular: 'Refund for nfl league (Week 15 cobra 2QB($450 to 1st)', trnType: 'Left', amount: '$22', balance: '$500.57', date: '18 Oct 2018' },
    { invoice: '4586', particular: 'Refund for nfl league (Week 15 cobra 2QB($450 to 1st)', trnType: 'Left', amount: '$22', balance: '$500.57', date: '18 Oct 2018' },
    { invoice: '4586', particular: 'Refund for nfl league (Week 15 cobra 2QB($450 to 1st)', trnType: 'Left', amount: '$22', balance: '$500.57', date: '18 Oct 2018' },
    { invoice: '4586', particular: 'Refund for nfl league (Week 15 cobra 2QB($450 to 1st)', trnType: 'Left', amount: '$22', balance: '$500.57', date: '18 Oct 2018' },
    { invoice: '4586', particular: 'Refund for nfl league (Week 15 cobra 2QB($450 to 1st)', trnType: 'Left', amount: '$22', balance: '$500.57', date: '18 Oct 2018' }
];
var PENDING_ELEMENT_DATA = [
    { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },
    { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },
    { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },
    { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },
    { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },
    { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },
    { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },
    { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },
];
